import { useCallback, useState } from 'react'
import { requestSiteProposalPermissions } from 'api/site'

const EMPTY_PERMISSIONS = {
  canProposeFromDraft: false,
  canNominate: false,
  isProposer: false,
  isCoProposer: false,
  siteExists: false
}

export const useSiteProposalPermissions = () => {
  const [permissions, setPermissions] = useState(EMPTY_PERMISSIONS)
  const [isLoadingPermissions, setIsLoadingPermissions] = useState(false)

  const refreshPermissions = useCallback(async (siteId, siteHistoryId) => {
    if (!siteId) {
      setPermissions(EMPTY_PERMISSIONS)
      return EMPTY_PERMISSIONS
    }

    setIsLoadingPermissions(true)
    try {
      const data = await requestSiteProposalPermissions(siteId, siteHistoryId)
      const normalized = {
        canProposeFromDraft: Boolean(data?.canProposeFromDraft),
        canNominate: Boolean(data?.canNominate),
        isProposer: Boolean(data?.isProposer),
        isCoProposer: Boolean(data?.isCoProposer),
        siteExists: Boolean(data?.siteExists)
      }
      setPermissions(normalized)
      return normalized
    } finally {
      setIsLoadingPermissions(false)
    }
  }, [])

  return {
    permissions,
    isLoadingPermissions,
    refreshPermissions
  }
}
